<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:21:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-20 16:00:35
-->
<template>
    <div>
        <div class="top">
            <div class="top-btn">
               <el-button style="margin-right:12px"  v-if="codeData.indexOf('53') != -1"   @click="add"  type="primary">新增访谈</el-button>            
                <a-button class="btn-two" v-if="codeData.indexOf('54') != -1" @click="tabooList"> 禁言名单 </a-button>
            </div>
            <div class="search">
                <a-input-group compact>
                <a-select
                v-model="selectName"
                style="width: 140px; background: #ccc;margin-left:12px"
                >
                <a-select-option
                    @click="selectFn(item.value)"
                    :key="index"
                    v-for="(item, index) in selectArr"
                >
                    {{ item.label }}
                </a-select-option>
                </a-select>
                <a-input
                v-model="seachValue"
                placeholder="请输入搜索内容"
                style="width: 173px"
                />
            </a-input-group>
               <el-button  @click="search" type="primary" 
                >查询</el-button 
                >
            </div>
        </div>
        <coententTable
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :pagination="pagination"
        :dataSource="dataSource"
        :customSlot="customSlot"
        :loading="loading"
        :y="height"
        @handleSizeChange="handleSizeChange"
        >   <template v-slot:interviewType="scopeVal">
            <div :class="[scopeVal.scope.interviewType == '最新访谈'?'collectStatus1':scopeVal.scope.interviewType == '往期访谈'?'collectStatus2':'']">
            {{
                scopeVal.scope.interviewType
            }}
            </div>
            </template>
            <template v-slot:interviewStartTime="scopeVal">
            <div >
               {{scopeVal.scope.interviewStartTime}} 至 {{scopeVal.scope.interviewEndTime}}
            </div>
            </template>
            <template v-slot:logo="scopeVal">
                <a-popover trigger="click">
                    <div class="content" slot="content">
                        <div style="font-size:16px;margin-bottom: 10px;">发布信息</div>
                        <div class="open-style" v-for="(item, index) in seeData" :key="index">
                            <div>发布人: {{ item.managementName || "--" }}</div>
                            <div>发布时间: {{ item.operateTime || "--" }}</div>
                        </div>
                    </div>
                    <a v-if="codeData.indexOf('55') != -1"  @click="seeLogo(scopeVal.scope.id)">查看</a>
                </a-popover>
            </template>
            <template v-slot:displayStatus="scopeVal">
                <a-switch  v-if="codeData.indexOf('187') != -1"  :v-model="scopeVal.scope.displayStatus" :checked="scopeVal.scope.displayStatus?true:false" @change="checked=> changeDisplayStatus(checked, scopeVal.scope.id)" />
            </template>
            <template v-slot:operation="scopeVal">
                <div style="display: flex">
                       <div
                        v-if="codeData.indexOf('56') != -1"
                        @click="editAdmin(scopeVal.scope.id)"
                        style="margin-right: 14px;width:66px"
                        class="btnTwo"
                        >详细信息</div
                        >
                        <div
                        v-if="codeData.indexOf('57') != -1"
                        @click="open(scopeVal.scope)"
                        class="btnThree"
                        >删除</div
                        >
                </div>
            </template>
        </coententTable>
        <el-dialog
            title="确认删除该在线访谈?"
            :visible.sync="dialogVisibleTwo"
            width="450px"
            custom-class="tips-box"
            :before-close="handleClose"
            top="17%"
            >
            <span
                >删除后，网站中将不再显示该在线访谈内容，以及相关的文字实录，图片和视频等信息，请谨慎删除</span
            >
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleTwo = false">取消</el-button>
                <el-button :loading="deleteShow" type="danger" @click="deleteOne()"
                >确认删除</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {findListPage,updateDisplayStatus,collectDelete,findLogList} from "./online_interview";
export default {
    components: {
        coententTable
    },
    data(){
        return{
            selectName:'访谈主题',
            selectkey:'interviewTheme',
            selectArr:[
                {
                    'label':'访谈主题',
                    'value':'interviewTheme'
                },
                {
                    'label':'访谈单位',
                    'value':'hostUnit'
                }
            ],
            seachValue:'',
            columns: [
                {
                    title: "访谈主题",
                    dataIndex: "interviewTheme",
                    ellipsis: true,
                    customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
                },
                {
                    title: "访谈时间",
                    dataIndex: "interviewStartTime",
                    ellipsis: true,
                    width: 400,
                    scopedSlots: { customRender: "interviewStartTime" },
                },
                {
                    title: "访谈类型",
                    dataIndex: "interviewType",
                    scopedSlots: { customRender: "interviewType" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "征集单位",
                    dataIndex: "hostUnit",
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "发布日志",
                    dataIndex: "logo",
                    scopedSlots: { customRender: "logo" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "是否显示",
                    dataIndex: "displayStatus",
                    scopedSlots: { customRender: "displayStatus" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "操作",
                    dataIndex: "operate",
                    scopedSlots: { customRender: "action" },
                    fixed: "right",
                    width: 200,
                },
            ],
            pagination: {
                current: 1,
                pageSize: 15,
                total: 0,
                pageSizeOptions: ["15", "25", "35"],
            },
            dataSource: [],
            customSlot: [
                {
                    name: "displayStatus",
                    customRender: "displayStatus",
                },
                {
                    name: "interviewType",
                    customRender: "interviewType",
                },
                {
                    name: "logo",
                    customRender: "logo",
                },
                 {
                    name: "interviewStartTime",
                    customRender: "interviewStartTime",
                }
            ],
            loading: false,
            height:0,
            collectTheme:'',//
            collectUnit:'',
            dialogVisibleTwo:false,
            item:{},
            seeData:[],
            codeData:[],
            deleteShow:false,
        }
    },
    mounted(){
        this.getListPage()
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    },
    methods: {
        tabooList(){
             this.$router.push({
                path: "/index/interaction/online_interview/forbidden_list",
                query: { 
                    title: "禁言名单",
                    islast:true,
                },
            });
        },
        selectFn(value){
            this.selectkey = value
        },
        add() {
            this.$router.push({
                path: "/index/interaction/online_interview/add",
                query: { 
                    title: "新增访谈",
                    isEdit: false,
                    islast:true,
                },
            });
        },
        openAddPage(){

        },
        open(item){
            this.item = JSON.parse(JSON.stringify(item))
            this.dialogVisibleTwo = true;
        },
        handleClose(){
            this.dialogVisibleTwo = false
        },
        search(){
            this.pagination.current = 1;
            this.getListPage()
        },
        onShowSizeChange(current) {
            this.pagination.current = current;
            this.getListPage();
        },
        handleSizeChange(pageSize){
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getListPage();
        },
        getListPage(){
            const _this = this
            _this.loading = true;
            let obj ={}
             _this.selectkey == 'interviewTheme'?obj.interviewTheme=_this.seachValue:obj.hostUnit=_this.seachValue
            let reqData = {
                ...obj,
                current:_this.pagination.current,
                siteId:sessionStorage.getItem("siteId"),
                size:_this.pagination.pageSize
            }
            findListPage(reqData).then(res=>{
                if(res.code == 0){
                    _this.dataSource = res.data.records
                    _this.pagination.current = res.data.current
                    _this.pagination.total = res.data.total
                    if(_this.pagination.total > 0){
                        this.height = document.documentElement.clientHeight - 370;
                        window.onresize = () => {
                        return (() => {
                            this.height = document.documentElement.clientHeight - 370;
                        })();
                        };
                    }
                    _this.pagination.pageSize = res.data.size
                    _this.loading = false;
                }
            })
        },
        changeDisplayStatus(displayStatus,id){
            updateDisplayStatus({displayStatus:displayStatus?1:0,id:id}).then(res=>{
                if(res.code == 0){
                    this.getListPage()
                }
            })
        },
        deleteOne(){
            this.deleteShow = true;
            collectDelete({id:this.item.id}).then((res)=>{
                if(res.code == 0){
                    this.dialogVisibleTwo = false;
                    this.getListPage()
                }
                 this.deleteShow = false;
            })
        },
        seeLogo(id){
           findLogList({id:id}).then(res=>{
               if(res.code == 0){
                   this.seeData = JSON.parse(JSON.stringify(res.data))
               }
           })
        },
        editAdmin(id){
            this.$router.push({
                path: "/index/interaction/online_interview/add",
                query: {
                    isCollectId: id,
                    isEdit: true,
                    islast:true,
                },
            });
        }
    },
};
</script>

<style lang="less" scoped>
    .top {
        width: 100%;
        padding: 24px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        .search {
            display: flex;
            width: 410px;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
        .add-img {
            margin-top: -2px;
            margin-right: 3px;
        }
    }
    .collectStatus1{
        color: #1890ff;
    }
    .collectStatus2{
        color: #909399;
    }
    /deep/.ant-switch-checked{
        background-color: #39d362;
    }
    .btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
  .el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
   height: 40px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-left: 12px;
}
/deep/ .ant-table-placeholder{
    
}
.top-btn{
    display: flex;
}
.btn-two{
  width: 96px;
  height: 40px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1);
  display: flex;
  align-items: center;
  justify-content:center;
  color: rgba(23, 109, 230, 1);
  cursor: pointer;
}
</style>